import { Modal, Text, Button, Spinner } from '@nimbus-ds/components';
import useTranslationCustomers from 'domains/Customers/hooks/useTranslationCustomers/useTranslationCustomers';

interface SubscriptionsCancelModalProps {
  show: boolean;
  isLoading?: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

function SubscriptionsCancelModal({
  show,
  isLoading = false,
  onDismiss,
  onConfirm,
}: Readonly<SubscriptionsCancelModalProps>) {
  const t = useTranslationCustomers('customerDetails.customerSubscriptions');

  return (
    <Modal open={show} onDismiss={onDismiss}>
      <Modal.Header title={t('cancelSubscription')} />
      <Modal.Body>
        <Text fontSize="base" lineHeight="base" textAlign="left">
          {t('cancelSubscriptionDisclaimer')}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onDismiss} disabled={isLoading}>
          {t('back')}
        </Button>
        <Button
          appearance="danger"
          disabled={isLoading}
          onClick={onConfirm || onDismiss}
        >
          {isLoading && <Spinner color="currentColor" size="small" />}
          {t('cancelSubscription')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SubscriptionsCancelModal;
